import { useMemo, useRef } from 'react';
import useTeams from '@/hooks/useTeams';
import { GenericSelect } from '@gettactic/components/src/primitives/Select/select-controls/GenericSelect';
import { useFilterContext } from '@gettactic/components/src/controls/FilterContext/FilterContext';
import * as React from 'react';
import { withFilterProvider } from '../../utils/withFilterProvider';
import { ITeam } from '@gettactic/api';
import { Option } from '@gettactic/helpers';

type Props = {
  onChange: (ids: string[] | string) => void;
  teams?: string[];
  includeFavs: boolean;
  className?: string;
  applyOnClick?: boolean;
  disabled?: boolean;
  triggerClassName?: string;
};

const V2SelectTeamsBeta2Base = ({
  className,
  onChange,
  teams = [],
  includeFavs = false,
  disabled = false,
  applyOnClick,
  triggerClassName
}: Props) => {
  const {
    filter,
    setFilter: setLocationFilter,
    resetFilter: resetLocationFilter
  } = useFilterContext();

  const { teamList } = useTeams({ type: 'directory', hidden: false });
  const { teamList: groups } = useTeams({ type: 'group', hidden: false });

  const [selectedValues, setSelectedValues] = React.useState<string[]>(teams);
  const dashboardTeamFilter = useRef(false);
  React.useEffect(() => {
    if(!dashboardTeamFilter.current && teams.length > 0) {
      dashboardTeamFilter.current = true;
      setSelectedValues(teams);
    }
  }, [teams]);

  const options = useMemo(() => {
    const elements = (teamList ? teamList.elements : []).concat(
      groups && includeFavs ? groups.elements : []
    );
    const options: Option[] = elements.map((x: ITeam) => ({
      label: x.name,
      value: x.id
    }));
    options.sort((a, b) => a.label.localeCompare(b.label));
    return options;
  }, [teamList, groups, includeFavs]);

  const handleChange = (values: string | string[]) => {
    const arrayedValues = Array.isArray(values)
      ? values
      : values
        ? [values]
        : [];

    setSelectedValues(arrayedValues);
    if (applyOnClick) {
      onChange(values);
    }
  };

  const handleApply = (values: string | string[]) => {
    onChange(Array.isArray(values) ? values : [values]);
  };

  return (
    <>
      {teamList && groups ? (
        <GenericSelect
          className={className}
          onCancel={() => onChange([])}
          onChange={handleChange}
          options={
            filter
              ? options.filter((option) =>
                  option.label.toLowerCase().includes(filter.toLowerCase())
                )
              : options
          }
          defaultValue={selectedValues}
          placeholder={includeFavs ? 'Teams & Lists' : 'All Teams'}
          isMultiSelect={true}
          showApplyButton={!applyOnClick}
          onApply={handleApply}
          showSearch={true}
          disabled={disabled}
          triggerClassName={triggerClassName}
        />
      ) : null}
    </>
  );
};

// Export the component wrapped with FilterProvider
export const SelectTeams = withFilterProvider(V2SelectTeamsBeta2Base);
